var map = {
	"./Noah-Kristel-01.11-03.mp3": 7279,
	"./Noah-Kristel-01.13-04.mp3": 4222,
	"./Noah-Kristel-01.15-05.mp3": 8277,
	"./Noah-Kristel-01.17-06.mp3": 2952,
	"./Noah-Kristel-01.19-07.mp3": 2867,
	"./Noah-Kristel-01.21-08.mp3": 3503,
	"./Noah-Kristel-01.23-09.mp3": 3564,
	"./Noah-Kristel-01.25-10.mp3": 7564,
	"./Noah-Kristel-01.29-12.mp3": 8602,
	"./Noah-Kristel-01.9-02.mp3": 8661,
	"./Noah-Kristel-02.1-01.mp3": 3887,
	"./Noah-Kristel-03.2-11.mp3": 5342,
	"./Noah-Kristel-04.3-13.mp3": 7834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6000;